import { Fade } from "react-awesome-reveal";
import "./consultancy-our-services.scss";

const ConsultancyOurServices = () => {
  return (
    <section className="consultancy-our-services">
      <Fade direction="up" duration={700} triggerOnce>
        <div className="consultancy-our-services__title-container">
          <h2 className="consultancy-our-services__title">
            Un Supporto Completo, Grazie alla Nostra Rete di Collaborazioni
          </h2>
          <div className="consultancy-our-services__title-divider" />
        </div>
      </Fade>
      <Fade
        direction="up"
        duration={800}
        delay={150}
        cascade
        damping={0.2}
        triggerOnce
      >
        <div className="consultancy-our-services__text-container">
          <p className="consultancy-our-services__text">
            Collaboriamo con ingegneri e studi geotecnici esterni per offrire un
            servizio completo di consulenza tecnica, dalla valutazione iniziale
            alla realizzazione
          </p>
          <p className="consultancy-our-services__text">
            Ti indirizziamo verso i professionisti più adatti e ci coordiniamo
            con loro per garantire continuità e precisione in ogni fase.
          </p>
        </div>
      </Fade>
    </section>
  );
};

export default ConsultancyOurServices;
